/* eslint-disable react/prop-types */
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Card, Col, Input, Label, Row, Spinner, FormGroup } from "reactstrap";
import { useDropzone } from "react-dropzone";
import Attachment from "../tables/Attachment";
import { postApi, apiURL } from "redux/action/api_tbeams";
import { useSelector } from "react-redux";
import { useToasts } from "helper/ToastAdapter";
import { getSector } from "helper";
import { formatNumber } from "redux/action/api";

export default function CreateMemo() {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((e) => e.auth.user);
  const { addToast } = useToasts();
  const mdaRef = useRef();
  const economicRef = useRef();
  const programRef = useRef();

  const params = new URLSearchParams(location.search);
  const memoType = params.get("type") || "";

  const [isLoading, setIsLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [balLoading, setBalLoading] = useState(false);
  const [mdaList, setMdaList] = useState([]);
  const [economicList, setEconomicList] = useState([]);
  const [programList, setProgramList] = useState([]);
  const imageId = moment().format("YYYYMMDDhhmmss");

  const [form, setForm] = useState({
    mda_code: "",
    mda_name: "",
    economic_code: "",
    economic_description: "",
    program_code: "",
    program_description: "",
    description: "",
    amount: "",
    mda_budget_balance: "",
    budget: "",
    imageId,
    memo_type: memoType,
  });

  const { acceptedFiles, getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } =
    useDropzone({ accept: { "image/*": [], "application/pdf": [] } });

  const handleChange = ({ target: { name, value } }) =>
    setForm((p) => ({ ...p, [name]: value }));

  useEffect(() => {
    setFetching(true);
    getSector({ type: "ADMINISTRATIVE SEGMENT" }, "select", (d) => {
      setMdaList(d || []);
    });
    getSector({ type: "ECONOMIC SEGMENT" }, "select", (d) => {
      setEconomicList(d || []);
    });
    getSector({ type: "PROGRAMME SEGMENT" }, "select", (d) => {
      setProgramList(d || []);
      setFetching(false);
    });
  }, []);

  const getBudgetBalance = useCallback(
    (economic_code) => {
      if (!economic_code || !form.mda_code) return;

      setBalLoading(true);
      postApi(`update_budget_balance`, {
        query_type: "select",
        mda_name: form.mda_name,
        mda_code: form.mda_code,
        amount: null,
        economic_code: economic_code,
        program_code: form.program_code || null,
      })
        .then((d) => {
          if (d.success && d.data?.[0]) {
            const selectedItem = d.data[0];
            setForm((p) => ({
              ...p,
              mda_budget_balance: selectedItem?.mopb_balance || 0,
              budget: selectedItem?.approve_amount || 0,
            }));
          }
        })
        .catch(console.log)
        .finally(() => setBalLoading(false));
    },
    [form.mda_code, form.mda_name, form.program_code]
  );

  const handleApi1 = async () => {
    if (acceptedFiles.length) {
      try {
        const formData = new FormData();
        formData.append("file", acceptedFiles[0]);
        
        const token = localStorage.getItem("@@auth_token");
        const response = await fetch(`${apiURL}/memo/upload`, {
          method: "POST",
          headers: {
            authorization: "Bearer " + token,
          },
          body: formData,
        });
        
        const data = await response.json();
        console.log("Upload response:", data);
        
        if (data.success) {
          setForm((p) => ({ ...p, document_path: data.filePath }));
          return data.filePath;
        } else {
          addToast(data.error || "File upload failed", { appearance: "error", autoDismiss: true });
          return null;
        }
      } catch (err) {
        console.log("Upload error:", err);
        addToast("File upload error: " + err.message, { appearance: "error", autoDismiss: true });
        return null;
      }
    }
    return null;
  };

  const handleSubmit = async () => {
    if (!form.mda_code || !form.economic_code || !form.amount || !form.description) {
      addToast("Please fill all required fields", { appearance: "error", autoDismiss: true });
      return;
    }
    if (parseFloat(form.amount) <= 0) {
      addToast("Amount must be positive", { appearance: "error", autoDismiss: true });
      return;
    }

    setIsLoading(true);
    try {
      // Upload file first if there's one
      let documentPath = null;
      if (acceptedFiles.length > 0) {
        documentPath = await handleApi1();
        if (!documentPath) {
          setIsLoading(false);
          return; // Stop if file upload failed
        }
      }

      const resp = await postApi("memo/create", {
        mda_code: form.mda_code,
        mda_name: form.mda_name,
        economic_code: form.economic_code,
        economic_description: form.economic_description,
        program_code: form.program_code || "",
        program_description: form.program_description || "",
        description: form.description,
        amount: form.amount,
        document_path: documentPath,
        created_by: user?.username,
        memo_type: "Secretary",
        imageId: imageId,
      });
      
      if (resp.success) {
        addToast("Memo created successfully", { appearance: "success", autoDismiss: true });
        navigate(-1);
      } else {
        addToast(resp.error || "Failed to create memo", { appearance: "error", autoDismiss: true });
      }
    } catch (err) {
      console.log("Submit error:", err);
      addToast("An error occurred: " + err.message, { appearance: "error", autoDismiss: true });
    } finally {
      setIsLoading(false);
    }
  };

  let programData = programList.filter(item => item.level >= 3);
let adminCode = mdaList.filter(item => item.level >= 3);
let economicCode = economicList.filter(item => item.level >= 3);

  return (
    <DashboardLayout>
      <MDBox pt={2} pb={3} pl={2}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="success"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h5" color="white">
                  {memoType ? `Create ${memoType} Memo` : "Create New Memo"}
                </MDTypography>
              </MDBox>

              <div style={{ padding: 20 }}>
                {fetching ? (
                  <div className="text-center"><Spinner color="primary" /> Loading...</div>
                ) : (
                  <>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>MDA *</Label>
                          <Typeahead
                            ref={mdaRef}
                            id="mda-selector"
                            labelKey={(opt) => `${opt.head} - ${opt.description}`}
                            options={adminCode}
                            placeholder="Select MDA"
                            onChange={(selected) => {
                              if (selected.length) {
                                setForm((p) => ({
                                  ...p,
                                  mda_code: selected[0].head,
                                  mda_name: selected[0].description,
                                  mda_budget_balance: "",
                                  budget: "",
                                }));
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Economic Code *</Label>
                          <Typeahead
                            ref={economicRef}
                            id="economic-selector"
                            labelKey={(opt) => `${opt.head} - ${opt.description}`}
                            options={economicCode}
                            placeholder="Select Economic Code"
                            onChange={(selected) => {
                              if (selected.length) {
                                setForm((p) => ({
                                  ...p,
                                  economic_code: selected[0].head,
                                  economic_description: selected[0].description,
                                }));
                                getBudgetBalance(selected[0].head);
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Program Code</Label>
                          <Typeahead
                            ref={programRef}
                            id="program-selector"
                            labelKey={(opt) => `${opt.head} - ${opt.description}`}
                            options={programData}
                            placeholder="Select Program Code"
                            onChange={(selected) => {
                              if (selected.length) {
                                setForm((p) => ({
                                  ...p,
                                  program_code: selected[0].head,
                                  program_description: selected[0].description,
                                }));
                              }
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Budget Amount</Label>
                          <Input
                            type="text"
                            value={balLoading ? "Loading..." : formatNumber(form.budget)}
                            disabled
                          />
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Budget Balance</Label>
                          <Input
                            type="text"
                            value={balLoading ? "Loading..." : formatNumber(form.mda_budget_balance)}
                            disabled
                            style={{
                              color: form.mda_budget_balance === "Budget Exausted" ? "red" : "green",
                              fontWeight: "bold",
                            }}
                          />
                        </FormGroup>
                      </Col>
                          <Col md={6}>
                        <FormGroup>
                          <Label>Amount *</Label>
                          <Input
                            type="number"
                            name="amount"
                            value={form.amount}
                            onChange={handleChange}
                            placeholder="Enter amount"
                          />
                        </FormGroup>
                      </Col>
                      <Col md={6}>
                        <FormGroup>
                          <Label>Description *</Label>
                          <Input
                            type="textarea"
                            name="description"
                            value={form.description}
                            onChange={handleChange}
                            rows={4}
                            placeholder="Enter memo description"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={12}>
                        <Attachment
                          acceptedFiles={acceptedFiles}
                          getRootProps={getRootProps}
                          getInputProps={getInputProps}
                          isDragActive={isDragActive}
                          isDragAccept={isDragAccept}
                          isDragReject={isDragReject}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col md={12}>
                        <Button color="secondary" onClick={() => navigate(-1)} className="me-2">
                          Cancel
                        </Button>
                        <Button color="primary" onClick={handleSubmit} disabled={isLoading}>
                          {isLoading ? <Spinner size="sm" /> : "Submit Memo"}
                        </Button>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
